<head>
  <!-- Font Awesome -->
  <link rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        crossorigin="anonymous"
        referrerpolicy="no-referrer" />
</head>
<div class="dsgnr-wrap">
  <main class="dsgnr-body" id="dsgnrContent" role="main">

    <div style="height:44px" aria-hidden="true" class="wp-block-spacer"></div>

    <section class="section-layout-block section-with-card">

      <!-- Hide this section when a form is open -->
      <div *ngIf="!currentForm" class="container single-content-layout-layout-block mb-5">
        <div class="row justify-content-center text-center">

          <div class="column-block col-12 col-md-10 col-lg-8 card-like card-like-lg text-center">

            <h1 class="wp-block-heading">
              {{ context === 'Share' ? 'Water Sharing' : 'Water Trading' }}
            </h1>
            <div class="container two-column-layout-layout-block two-button-container my-5 water-buttons-section">
              <div class="row align-items-center">

                <!-- I HAVE WATER -->
                <div class="column-block col-12 col-lg-6 text-center">
                  <div class="wp-block-buttons">
                    <div class="wp-block-button btn-square-container need-water">
                      <a class="wp-block-button__link wp-element-button"
                         (click)="openForm('Have')">
                        I Have Water
                      </a>
                    </div>
                  </div>
                </div>

                <!-- I NEED WATER -->
                <div class="column-block col-12 col-lg-6 text-center">
                  <div class="wp-block-buttons">
                    <div class="wp-block-button btn-square-container have-water">
                      <a class="wp-block-button__link wp-element-button"
                         (click)="openForm('Need')">
                        I Need Water
                      </a>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- FORM APPEARS HERE -->
      <div *ngIf="currentForm">
        <ws-request-form [type]="currentForm" [context]="context"></ws-request-form>
      </div>

    </section>

  </main>
</div>
